import { useEffect, useMemo } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { getHasCareCreditUrl } from '../actions';

const useCareCreditValidation = () => {
  const dispatch = useDispatch();
  const store = useSelector(({
    personalInformation,
    policies,
  }) => ({
    personalInformation,
    policies,
  }), shallowEqual);

  const {
    personalInformation: { discountData },
    policies: { careCredit },
  } = store;

  const costcoCustomer = useMemo(() => Boolean(discountData
    && discountData.id && discountData.memberId), [discountData]);

  useEffect(() => {
    if (!costcoCustomer) {
      // care credit request only for Figo users, but non Costco
      dispatch(getHasCareCreditUrl());
    }
  }, []);

  return {
    careCredit: {
      careCreditUrl: String(careCredit.careCreditUrl),
      hasCareCreditUrl: Boolean(careCredit.hasCareCreditUrl),
      loading: Boolean(careCredit.loading),
    },
  };
};

export { useCareCreditValidation };
